import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import MediaSection from '@/pages/home/components/MediaSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CardsSection from '@/pages/home/components/CardsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import RankingSection from '@/pages/home/components/RankingSection';
import ContactSection from '@/pages/home/components/ContactSection';
import AppSection from '@/pages/home/components/AppSection';
import IndexSection from '@/pages/home/components/IndexSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import FAQSection from '@/pages/home/components/FAQSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CommentsSection />
        <UpdatesSection />
        <AboutSection />
        <CardsSection />
        <FeaturesSection />
        <TopicsSection />
        <RankingSection />
        <ContactSection />
        <AppSection />
        <IndexSection />
        <CarouselSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}